export const reservationConversations = {
  tabs: {
    calls: "Chiamate",
    web: "Web",
    checkins: "Check-in",
    charges: "Addebiti",
    notes: "Note",
  },
  checkinBadge: {
    allCompleted: "Tutti i check-in completati",
    manuallyResolved: "Consegna finale completata manualmente da un operatore",
    progress: "{done}/{total} check-in completati",
  },
  banners: {
    limitedMode:
      "Questa prenotazione non è configurata per il flusso completo. Puoi utilizzare solo WhatsApp e le note interne.",
    rejectedMode:
      "La richiesta è stata rifiutata. Restano disponibili solo WhatsApp e le note interne.",
    autoReplying: "L'agente sta rispondendo automaticamente.",
  },
  search: {
    placeholder: "Cerca per nome, telefono o codice di prenotazione...",
  },
  list: {
    emptyTitle: "Ancora nessuna conversazione",
    emptyText:
      "Quando l'ospite scrive o invii un messaggio, la conversazione apparirà qui.",
    noResultsTitle: "Nessuna conversazione trovata",
    noResultsText: "Prova con un altro nome, telefono o codice di prenotazione.",
    aiActiveTitle: "Agente IA attivo",
    markAllRead: "Segna tutte come lette",
  },
  conversation: {
    windowTimer: "Finestra di messaggistica: {hours}h rimanenti",
    copyPortalCopied: "Link copiato",
    copyPortalTooltip: "Copia il link di gestione",
    copiedShort: "Copiato",
    copyLinkShort: "Copia link",
    dropToAttach: "Rilascia per allegare i file",
    senderBot: "BOT / STAFF",
    senderGuest: "OSPITE",
    imageAlt: "Immagine inviata",
    locationReceived: "Posizione ricevuta",
    viewFile: "Visualizza file",
    notSent: "Non inviato",
    sending: "Invio in corso...",
    emptyTitle: "Ancora nessun messaggio",
    emptyText:
      "Avvia la conversazione con un modello o attendi che l'ospite scriva.",
  },
  mode: {
    ai: "IA",
    manual: "Manuale",
    agentInactiveTooltip:
      "L'Agente IA non è attivo per questo alloggio. Attivalo dalle impostazioni dell'annuncio affinché risponda automaticamente.",
    agentInactiveChip: "Agente IA inattivo",
  },
  composer: {
    predefinedTitle: "Risposte predefinite",
    predefinedEmpty: "Nessuna risposta predefinita trovata",
    attachFile: "Allega file",
    inputPlaceholder: "Inizia con / per selezionare una risposta predefinita.",
    removeFile: "Rimuovi file",
    fileFallback: "file",
  },
  calls: {
    title: "Chiamate per questa prenotazione",
    none: "Nessuna chiamata collegata a questa prenotazione.",
    caller: "Chiamante",
    bookedFromCall: "Prenotato da questa chiamata",
    pause: "Pausa",
    play: "Riproduci",
    downloadMp3: "Scarica MP3",
    noRecording: "Nessuna registrazione",
  },
  ota: {
    noData: "Nessun dato di prenotazione per caricare i messaggi OTA.",
  },
  checkins: {
    title: "Check-in della prenotazione",
  },
  charges: {
    title: "Addebiti della prenotazione",
    noData: "Nessun dato di prenotazione per caricare gli addebiti.",
  },
  notes: {
    title: "Note interne",
    noData: "Nessun dato di prenotazione per caricare le note.",
  },
  time: {
    today: "Oggi {time}",
    yesterday: "Ieri {time}",
  },
  guestFallback: "Ospite",
  webGuestFallback: "Ospite",
  documentFallback: "Documento",
  location: {
    openInMaps: "Apri in Google Maps",
    viewCoords: "Visualizza coordinate ({lat}, {lng})",
  },
  delivery: {
    read: "Letto",
    delivered: "Consegnato",
    queued: "In coda",
    failed: "Non riuscito",
    sent: "Inviato",
  },
  errors: {
    genericSendFail: "Impossibile inviare questo messaggio tramite WhatsApp.",
  },
  failureShort: {
    paymentIssue: "problema di pagamento sull'account WhatsApp",
    cannotReceive: "il numero non può ricevere messaggi WhatsApp",
    downloadFailed: "WhatsApp non è riuscito a scaricare il file",
    templateMissingData: "dati del modello mancanti",
    requirementsNotMet: "il messaggio non soddisfa i requisiti di WhatsApp",
  },
  failureTitle: {
    noWhatsapp: "Nessun WhatsApp",
    invalidNumber: "Numero non valido",
    notSent: "Non inviato",
  },
  alerts: {
    paymentIssue: "Problema di pagamento su WhatsApp",
    whatsappUnavailable: "WhatsApp non disponibile",
    qualityReduced: "Qualità del numero ridotta",
  },
  toast: {
    reactivateNoConv: "Impossibile identificare la conversazione da riattivare.",
    templateSent: "Modello inviato con successo.",
    reactivateFail: "Impossibile inviare il modello di riattivazione.",
    cannotSendWhatsappTitle: "Impossibile inviare tramite WhatsApp",
    invalidPhoneDetail:
      "Il telefono di questa prenotazione ({phone}) non è un numero valido. Correggilo in \"Modifica prenotazione\" per poterlo contattare.",
    noPhoneDetail:
      "Questa prenotazione non ha un telefono. Aggiungilo in \"Modifica prenotazione\" per poterlo contattare.",
    sendErrorTitle: "Errore di invio",
    sendErrorDetail: "Impossibile inviare il messaggio",
    errorTitle: "Errore",
    copyLinkFail: "Impossibile copiare il link",
    agentInactiveTitle: "Agente IA inattivo",
    agentInactiveDetail:
      "Questo alloggio non ha l'Agente IA attivo. Attivalo dalle impostazioni dell'annuncio.",
    noConvId: "Impossibile identificare la conversazione",
    modeChangeFail: "Impossibile cambiare la modalità della chat",
    agentUnavailableTitle: "Agente IA non disponibile",
  },
};
